import { ENV } from "../utils";
import { apiFetch } from "./httpClient";

export class Role {
  async getRoles() {
    return apiFetch(ENV.API_ROUTES.ROLE, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    });
  }

  async getRole(roleId) {
    return apiFetch(`${ENV.API_ROUTES.ROLE}/${roleId}`, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    });
  }

  async createRole(data) {
    return apiFetch(ENV.API_ROUTES.ROLE, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
      expectedStatus: 201,
    });
  }

  async updateRole(roleId, data) {
    return apiFetch(`${ENV.API_ROUTES.ROLE}/${roleId}`, {
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    });
  }

  async deleteRole(roleId) {
    return apiFetch(`${ENV.API_ROUTES.ROLE}/${roleId}`, {
      method: "DELETE",
    });
  }

  async getRolePermissions(roleId, section) {
    return apiFetch(`${ENV.API_ROUTES.ROLE}/${roleId}/permissions/${section}`, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    });
  }

  async createRolePermission(data) {
    return apiFetch(`${ENV.API_ROUTES.ROLE}/permission`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
      expectedStatus: 201,
    });
  }

  async deleteRolePermission(rolePermissionId) {
    return apiFetch(`${ENV.API_ROUTES.ROLE}/permission/${rolePermissionId}`, {
      method: "DELETE",
    });
  }
}
